<template>
	<b-modal ref="modal" hide-footer size="lg" @hidden="onHidden">
		<template v-slot:modal-title>
			{{ form.tiersaddress_id ? $t('tiers.address.modifier_titre') : $t('tiers.address.ajouter_titre') }}
		</template>

		<form @submit.prevent="onSubmit">
			<div class="row mt-2">
				<label for="tiersaddress_label" class="col-sm-4 col-form-label">{{ $t('tiers.address.label') }} *</label>
				<div class="col-sm-8">
					<input
						type="text"
						id="tiersaddress_label"
						class="form-control"
						v-model="form.tiersaddress_label"
						required
					/>
				</div>
			</div>

			<div class="row mt-2">
				<label for="tiersaddress_address1" class="col-sm-4 col-form-label">{{ $t('tiers.address.address1') }} *</label>
				<div class="col-sm-8">
					<input
						type="text"
						id="tiersaddress_address1"
						class="form-control"
						v-model="form.tiersaddress_address1"
						required
					/>
				</div>
			</div>

			<div class="row mt-2">
				<label for="tiersaddress_address2" class="col-sm-4 col-form-label">{{ $t('tiers.address.address2') }}</label>
				<div class="col-sm-8">
					<input
						type="text"
						id="tiersaddress_address2"
						class="form-control"
						v-model="form.tiersaddress_address2"
					/>
				</div>
			</div>

			<div class="row mt-2">
				<label for="tiersaddress_postalcode" class="col-sm-4 col-form-label">{{ $t('tiers.address.postalcode') }} *</label>
				<div v-if="is_french" class="col-sm-8">
					<input
						type="text"
						id="tiersaddress_postalcode"
						class="form-control"
						v-if="form.tiersaddress_postalcode"
						v-model="form.tiersaddress_postalcode"
						required
						autocomplete="chrome-off"
						@click="resetPostalCode"
					/>
					<SearchInputCommune
						v-if="isOnline && !form.tiersaddress_postalcode"
						:town="0"
						:tiers_postalcode.sync="form.tiersaddress_postalcode"
						:tiers_town.sync="form.tiersaddress_town"
					/>
				</div>
				<div v-else class="col-sm-8">
					<input
						type="text"
						id="tiersaddress_postalcode_nofrench"
						class="form-control"
						v-model="form.tiersaddress_postalcode"
						required
					/>
				</div>
			</div>

			<div class="row mt-2">
				<label for="tiersaddress_town" class="col-sm-4 col-form-label">{{ $t('tiers.address.town') }} *</label>
				<div v-if="is_french" class="col-sm-8">
					<input
						type="text"
						id="tiersaddress_town"
						class="form-control"
						v-if="form.tiersaddress_town"
						v-model="form.tiersaddress_town"
						required
						autocomplete="chrome-off"
						@click="resetTown"
					/>
					<SearchInputCommune
						v-if="isOnline && !form.tiersaddress_town"
						:town="1"
						:tiers_postalcode.sync="form.tiersaddress_postalcode"
						:tiers_town.sync="form.tiersaddress_town"
					/>
				</div>
				<div v-else class="col-sm-8">
					<input
						type="text"
						id="tiersaddress_town_nofrench"
						class="form-control"
						v-model="form.tiersaddress_town"
						required
					/>
				</div>
			</div>

			<div class="row mt-2">
				<label for="tiersaddress_country" class="col-sm-4 col-form-label">{{ $t('tiers.address.country') }} *</label>
				<div class="col-sm-8">
					<CountryInput v-model="form.tiersaddress_country"></CountryInput>
				</div>
			</div>

			<div class="row mt-2" v-if="form.tiersaddress_trace">
				<label for="tiersaddress_trace" class="col-sm-4 col-form-label">{{ $t('table.tiers_addresses.tiersaddress_trace') }}</label>
				<div class="col-sm-8">
					<input
						type="text"
						id="tiersaddress_trace"
						class="form-control"
						:value="form.tiersaddress_trace"
						readonly
					/>
				</div>
			</div>

			<div class="row mt-2" v-if="hasRegions">
				<label for="tiersaddress_region" class="col-sm-4 col-form-label">{{ $t('tiers.address.region') }}</label>
				<div class="col-sm-8">
					<e-select
						id="tiersaddress_region"
						v-model="form.tiersaddress_region"
						:options="regions[form.tiersaddress_country]"
						:allow-empty="true"
						:show-labels="true"
					/>
				</div>
			</div>

			<div class="text-center mt-4">
				<b-button type="submit" variant="primary" :disabled="processing">
					<font-awesome-icon v-if="processing" :icon="['fas', 'spinner']" pulse />
					{{ $t('global.enregistrer') }}
					<span class="ml-1 small text-white-50">({{ isMac ? '⌘' : 'Ctrl' }}+S)</span>
				</b-button>
			</div>
		</form>

		<ActionOverlay ref="saveOverlay" />
	</b-modal>
</template>

<script type="text/javascript">
	import Regions from '@/assets/lang/countries/regions'
	import Tiers from "@/mixins/Tiers.js"

	export default {
		name: "TiersAddressForm",
		mixins: [Tiers],
		props: {
			tiers_id: { type: Number, required: true }
		},
		data() {
			return {
				processing: false,
				is_french: true,
				regionWhitelist: [104],
				regions: Regions,
				saveHandler: null,
				default_form: {
					tiersaddress_id: null,
					tiersaddress_label: '',
					tiersaddress_address1: '',
					tiersaddress_address2: '',
					tiersaddress_postalcode: '',
					tiersaddress_town: '',
					tiersaddress_country: this.getConfig('country', '75'),
					tiersaddress_region: '',
					tiersaddress_trace: null
				},
				form: {}
			}
		},
		mounted() {
			this.form = { ...this.default_form }
		},
		beforeDestroy() {
			this.unbindSaveShortcut()
		},
		methods: {
			/**
			 * Ouvre la modal en mode création ou édition.
			 *
			 * @param {object|null} address Données de l'adresse à éditer, null pour création.
			 */
			open(address = null) {
				if (address) {
					this.form = {
						tiersaddress_id: address.tiersaddress_id,
						tiersaddress_label: address.tiersaddress_label || '',
						tiersaddress_address1: address.tiersaddress_address1 || '',
						tiersaddress_address2: address.tiersaddress_address2 || '',
						tiersaddress_postalcode: address.tiersaddress_postalcode || '',
						tiersaddress_town: address.tiersaddress_town || '',
						tiersaddress_country: address.tiersaddress_country || this.getConfig('country', '75'),
						tiersaddress_region: address.tiersaddress_region || '',
						tiersaddress_trace: address.tiersaddress_trace || null
					}
					if (!this.form.tiersaddress_region) {
						this.detectRegion()
					}
				} else {
					this.form = { ...this.default_form }
				}
				this.is_french = parseInt(this.form.tiersaddress_country) === 75
				this.$refs.modal.show()
				this.bindSaveShortcut()
			},
			close() {
				this.$refs.modal.hide()
			},
			onHidden() {
				this.form = { ...this.default_form }
				this.unbindSaveShortcut()
			},
			bindSaveShortcut() {
				this.unbindSaveShortcut()
				this.saveHandler = (e) => {
					if ((this.isMac ? e.metaKey : e.ctrlKey) && e.key.toLowerCase() === 's') {
						e.preventDefault()
						if (!this.processing) {
							this.onSubmit()
						}
					}
				}
				window.addEventListener('keydown', this.saveHandler)
			},
			unbindSaveShortcut() {
				if (this.saveHandler) {
					window.removeEventListener('keydown', this.saveHandler)
					this.saveHandler = null
				}
			},
			/**
			 * Tente de détecter automatiquement la région depuis les champs adresse.
			 * Parcourt address1, address2 et town à la recherche d'un nom de région connu
			 * pour le pays sélectionné. Ne s'applique que si le pays a des régions définies
			 * et que la région n'est pas déjà renseignée.
			 */
			detectRegion() {
				const country = parseInt(this.form.tiersaddress_country)
				if (!this.regions[country] || !this.regions[country].length) return

				const haystack = [
					this.form.tiersaddress_address1,
					this.form.tiersaddress_address2,
					this.form.tiersaddress_town
				].filter(Boolean).join(' ').toUpperCase()

				const match = this.regions[country].find(region => {
					const normalized = region.toUpperCase()
					// Variantes irlandaises : "CO. CORK" → aussi "CO CORK" et "COUNTY CORK"
					const county = normalized.replace(/^CO\.\s*/, '')
					return (
						haystack.includes(normalized) ||
						haystack.includes('CO ' + county) ||
						haystack.includes('COUNTY ' + county)
					)
				})

				if (match) {
					this.form.tiersaddress_region = match
				}
			},
			resetPostalCode() {
				this.form.tiersaddress_postalcode = ''
			},
			resetTown() {
				this.form.tiersaddress_town = ''
			},
			async onSubmit() {
				if (this.processing) {
					return
				}
				this.processing = true
				this.$refs.saveOverlay.show(this.$t('global.enregistrement_en_cours'))
				const payload = { ...this.form }
				delete payload.tiersaddress_id
				const result = await this.saveTiersAddress(this.tiers_id, payload, this.form.tiersaddress_id)
				if (result) {
					await this.$refs.saveOverlay.showSuccess(this.$t('global.enregistrement_succes'))
					this.processing = false
					this.$emit('submit')
					this.close()
				} else {
					this.$refs.saveOverlay.hide()
					this.processing = false
					this.failureToast('toast.info_save_failed')
				}
			}
		},
		computed: {
			isOnline() {
				return window.navigator.onLine
			},
			hasRegions() {
				return this.regionWhitelist.includes(parseInt(this.form.tiersaddress_country))
			}
		},
		watch: {
			'form.tiersaddress_country' (val) {
				this.is_french = parseInt(val) === 75
			},
			'form.tiersaddress_address1' () {
				if (!this.form.tiersaddress_region) this.detectRegion()
			},
			'form.tiersaddress_address2' () {
				if (!this.form.tiersaddress_region) this.detectRegion()
			},
			'form.tiersaddress_town' () {
				if (!this.form.tiersaddress_region) this.detectRegion()
			}
		},
		components: {
			CountryInput: () => import('GroomyRoot/components/Inputs/CountryInput'),
			SearchInputCommune: () => import('@/components/Inputs/SearchInputCommune'),
			ActionOverlay: () => import('@/components/Utils/ActionOverlay')
		}
	}
</script>
